import { Flex } from 'antd';
import styled from 'styled-components';

export const Container = styled(Flex).attrs({
  gap: 20,
  vertical: true,
})`
  background-color: #fff;
  padding: 20px;
  &.bordered {
    border-bottom: 1px solid #dededf;
  }
`;

export const BackButton = styled.div`
  margin-right: 20px;
  height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;

export const Title = styled(Flex)`
  margin: 0;
  color: #2d3b21;
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
  &.secondary {
    color: ${(props) => props.theme.antd?.colorPrimary};
    font-size: 18px;
  }
`;

export const TitleTag = styled.span`
  margin-left: 8px;
  color: ${(props) => props.theme.antd?.colorPrimary};
  font-size: 14px;
  font-weight: 500;
`;
